import { Link } from "react-router-dom";
import { homeFor, useAuth } from "@/context/AuthContext";

export default function NotFound() {
  const auth = useAuth();
  const to = auth.status === "authenticated" ? homeFor(auth.user) : "/sign-in";
  return (
    <div className="flex min-h-screen flex-col items-start justify-center bg-graphite-950 px-8 sm:px-16">
      <p className="bz-caption text-electric">404</p>
      <h1 className="mt-3 font-display text-4xl font-bold tracking-tight text-white sm:text-5xl">This route does not exist.</h1>
      <Link to={to} data-testid="not-found-home-link" className="bz-btn-secondary mt-8">
        Take me somewhere safe
      </Link>
    </div>
  );
}
